import { ReactElement } from 'react';
import { history } from 'umi';
import { Row, Col, Statistic, Divider, Tooltip } from 'antd';
import { Typography, Button, Input } from 'iglooform';
import { CreditCardOutlined } from 'iglooicon';
import { useIntl } from 'react-intl';
import './cash-out.less';
import { AlertFilled } from 'iglooicon';

interface IEarningCardOutCard {
  account: Account;
  currentLang: string;
  handleFormatter: (value: any) => string;
  amountStr: string;
  handleAmountChange: (value: any) => void;
  setAmountStr: (value: any) => any;
  _balance: number;
  setAmount: (value: any) => any;
  amount: number;
  handleWithdrawal: () => any;
  btnLoading: boolean;
}

const CashOut = ({
  account,
  currentLang,
  handleFormatter,
  amountStr,
  handleAmountChange,
  setAmountStr,
  _balance,
  setAmount,
  amount,
  handleWithdrawal,
  btnLoading,
}: IEarningCardOutCard): ReactElement => {
  const { formatMessage } = useIntl();

  return (
    <Row className="cashout-amount-container">
      <Col span={12} className="account-container">
        <section className="account-title">
          <Typography level="body2">
            {formatMessage({ id: 'Cash out to' })}
          </Typography>
        </section>
        <section className="account">
          <section className="account-num-name">
            <section className="account-number">
              <CreditCardOutlined
                style={{ color: '#5858FF', fontSize: '24px' }}
              />
              <Typography
                level="body1"
                style={{ marginLeft: '8px', color: '#212121' }}
              >
                {account?.account_number}
              </Typography>
            </section>
            <section className="account-name">
              <Typography
                level="body1"
                style={{ marginLeft: '34px', color: '#212121' }}
              >
                {account?.holder_name}{' '}
              </Typography>
            </section>
          </section>
          <section
            className="change-btn"
            onClick={() =>
              history.push(`/me/verify-payment-password/change-account`)
            }
          >
            <Button style={{ borderRadius: '5px', height: '46px' }}>
              {formatMessage({ id: 'Change' })}
            </Button>
          </section>
        </section>
        <section className="request-amount-container">
          <section className="request-amount-info">
            <section className="account-title">
              <Typography level="body3" style={{ color: '#999' }}>
                {formatMessage({ id: 'Request Amount' })}
              </Typography>
            </section>
            <section className="amount-input-container">
              <Input
                bordered={false}
                size="large"
                prefix={
                  <Typography level="body1" style={{ color: '#212121' }}>
                    {formatMessage({ id: 'VND' })}
                  </Typography>
                }
                value={handleFormatter(amountStr)}
                onChange={handleAmountChange}
                autoFocus
                className="input"
              />
              <Divider style={{ margin: 0 }} />
            </section>
            <section className="available-amount">
              <Typography level="body3">
                {formatMessage({ id: 'Available Amount: ' })}
              </Typography>
              <Statistic
                style={{ display: 'inline-block' }}
                value={_balance}
                valueStyle={{ color: '#999', fontSize: '12px' }}
                prefix={formatMessage({ id: 'VND' })}
                groupSeparator={currentLang === 'vi-VN' ? '.' : ','}
                decimalSeparator={currentLang === 'vi-VN' ? ',' : '.'}
              />
              <Button
                type="link"
                className="cashout-all"
                onClick={() => {
                  setAmountStr(handleFormatter(_balance));
                  setAmount(_balance);
                }}
              >
                <Typography
                  level="body3"
                  style={{ display: 'block', marginTop: '-2px' }}
                >
                  {formatMessage({ id: 'Cash out All' })}
                </Typography>
              </Button>
            </section>
            <section className="net-cash">
              <Typography
                level="body1"
                style={{
                  display: 'block',
                  float: 'left',
                  marginRight: '4px',
                  fontSize: '12px',
                  lineHeight: '18px',
                }}
              >
                {formatMessage({ id: 'Net Cash Amount: ' })}
              </Typography>
              <Statistic
                className="net-cash-ava"
                value={_balance}
                prefix={formatMessage({ id: 'VND' })}
                valueStyle={{
                  color: '#999',
                  fontSize: '12px',
                  lineHeight: '18px',
                }}
                groupSeparator={currentLang === 'vi-VN' ? '.' : ','}
                decimalSeparator={currentLang === 'vi-VN' ? ',' : '.'}
              />
              <Tooltip
                placement={'bottom'}
                title={formatMessage({
                  id: 'This is the total amount that can be cashed out after goverment mandated income taxation of 10% on your total earnings.',
                })}
              >
                <AlertFilled style={{ fontSize: '16px' }} />
              </Tooltip>
            </section>
          </section>
          <section className="cashout-btn">
            <Button
              type="primary"
              disabled={!amount || isNaN(amount) || amount > _balance}
              onClick={() => handleWithdrawal()}
              loading={btnLoading}
              block
            >
              {formatMessage({ id: 'Cash out' })}
            </Button>
          </section>
        </section>
      </Col>
    </Row>
  );
};

export default CashOut;
